var _defs, _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg404(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_404",
    "data-name": 404,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 584.68,
    height: 585.172,
    viewBox: "0 0 584.68 585.172",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2221",
    "data-name": "Ret\\xE2ngulo 2221",
    width: 584.68,
    height: 585.172,
    fill: "none"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1580",
    "data-name": "Caminho 1580",
    d: "M308.565,152.969H271.776v47.576H244.945V152.969h-107.6V133.607L236.371,6.921h29.873l-94.876,122.26h74.407V87.137h26v42.044h36.789Z",
    transform: "translate(-93.427 -4.708)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1158",
    "data-name": "Grupo 1158"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1157",
    "data-name": "Grupo 1157",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1581",
    "data-name": "Caminho 1581",
    d: "M763,186.3q-17.84-11.753-28.075-34.161T724.693,99.025q0-30.7,10.234-53.108T763,11.756Q780.844,0,803.8,0q22.678,0,40.523,11.756T872.4,45.917q10.23,22.4,10.234,53.108T872.4,152.134Q862.165,174.54,844.325,186.3T803.8,198.051q-22.962,0-40.8-11.756m78-31.948q13.964-19.086,13.968-55.321T841.006,43.7q-13.971-19.086-37.2-19.086-23.513,0-37.48,19.086T752.354,99.025q0,36.24,13.969,55.321t37.48,19.086q23.235,0,37.2-19.086",
    transform: "translate(-492.961)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1582",
    "data-name": "Caminho 1582",
    d: "M1464.229,152.969h-36.789v47.576H1400.61V152.969h-107.6V133.607L1392.036,6.921h29.873l-94.876,122.26h74.407V87.137h26v42.044h36.789Z",
    transform: "translate(-879.549 -4.708)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1583",
    "data-name": "Caminho 1583",
    d: "M281.524,166.2H244.735v47.576H217.9V166.2H110.3V146.84L209.33,20.153H239.2l-94.876,122.26h74.407V100.37h26v42.044h36.789Z",
    transform: "translate(-75.033 -13.709)",
    fill: "#ffbe00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1584",
    "data-name": "Caminho 1584",
    d: "M735.962,199.528q-17.841-11.753-28.075-34.161t-10.234-53.108q0-30.7,10.234-53.108t28.075-34.161q17.842-11.753,40.8-11.756,22.678,0,40.523,11.756T845.36,59.15q10.23,22.4,10.234,53.108T845.36,165.367q-10.236,22.406-28.075,34.161t-40.523,11.756q-22.962,0-40.8-11.756m78-31.948q13.964-19.086,13.968-55.321T813.965,56.937q-13.971-19.086-37.2-19.086-23.513,0-37.48,19.086t-13.969,55.321q0,36.24,13.969,55.321t37.48,19.086q23.235,0,37.2-19.086",
    transform: "translate(-474.567 -9.002)",
    fill: "#ffbe00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1585",
    "data-name": "Caminho 1585",
    d: "M1437.188,166.2H1400.4v47.576h-26.831V166.2h-107.6V146.84l99.026-126.686h29.873l-94.876,122.26H1374.4V100.37h26v42.044h36.789Z",
    transform: "translate(-861.155 -13.709)",
    fill: "#ffbe00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1586",
    "data-name": "Caminho 1586",
    d: "M518.581,829.472,508.16,807.21l-13.842,6.512A52.9,52.9,0,0,0,481.8,802.285l5.2-14.421-23.071-8.355-5.2,14.421a52.728,52.728,0,0,0-16.92.777l-6.5-13.876-22.206,10.447,6.5,13.876a52.946,52.946,0,0,0-11.409,12.55L393.808,812.5l-8.333,23.129,14.385,5.209a53.119,53.119,0,0,0,.775,16.962l-13.989,7.315,10.569,21.459,13.841-6.511a52.891,52.891,0,0,0,12.519,11.437l-5.2,14.421,23.071,8.354,5.2-14.421a52.717,52.717,0,0,0,16.919-.777l6.5,13.876L492.268,902.5l-6.5-13.876a52.931,52.931,0,0,0,11.409-12.55l14.385,5.209,8.334-23.129-14.386-5.209a53.117,53.117,0,0,0-.775-16.962Zm-52.752,45.49a31,31,0,1,1,14.861-41.246,30.9,30.9,0,0,1-14.861,41.246",
    transform: "translate(-262.213 -530.248)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1587",
    "data-name": "Caminho 1587",
    d: "M439.949,913.475a.706.706,0,0,1-.24-.042l-23.071-8.355a.7.7,0,0,1-.423-.9l5.008-13.9a53.537,53.537,0,0,1-11.871-10.844l-13.337,6.275a.705.705,0,0,1-.933-.327l-10.569-21.459a.7.7,0,0,1,.306-.936l13.518-7.069a53.76,53.76,0,0,1-.739-16.109l-13.864-5.02a.706.706,0,0,1-.423-.9l8.334-23.129a.705.705,0,0,1,.9-.425l13.862,5.02a53.569,53.569,0,0,1,10.818-11.9l-6.26-13.374a.705.705,0,0,1,.338-.937l22.207-10.448a.713.713,0,0,1,.54-.024.7.7,0,0,1,.4.364l6.26,13.373a53.288,53.288,0,0,1,16.041-.736l5.008-13.9a.7.7,0,0,1,.9-.424l23.071,8.354a.705.705,0,0,1,.423.9l-5.008,13.9a53.53,53.53,0,0,1,11.871,10.844l13.337-6.275a.713.713,0,0,1,.54-.025.7.7,0,0,1,.4.365l10.421,22.262a.705.705,0,0,1-.338.938l-13.34,6.275a53.732,53.732,0,0,1,.735,16.086l13.864,5.02a.7.7,0,0,1,.423.9l-8.333,23.13a.7.7,0,0,1-.364.4.7.7,0,0,1-.54.025l-13.862-5.02a53.553,53.553,0,0,1-10.818,11.9l6.26,13.375a.7.7,0,0,1-.338.937L468.86,912.086a.7.7,0,0,1-.939-.34l-6.26-13.372a53.35,53.35,0,0,1-16.041.736l-5.008,13.9a.7.7,0,0,1-.663.466m-22.169-9.483,21.744,7.875,4.957-13.757a.708.708,0,0,1,.745-.461,51.9,51.9,0,0,0,16.693-.766.7.7,0,0,1,.784.391l6.2,13.236,20.931-9.848-6.2-13.238a.705.705,0,0,1,.2-.851,52.164,52.164,0,0,0,11.256-12.383.705.705,0,0,1,.831-.278l13.721,4.969,7.855-21.8-13.724-4.969a.706.706,0,0,1-.46-.744,52.359,52.359,0,0,0-.765-16.737.706.706,0,0,1,.39-.783l13.2-6.212-9.823-20.986-13.2,6.211a.709.709,0,0,1-.853-.2,52.143,52.143,0,0,0-12.352-11.285.7.7,0,0,1-.277-.829l4.956-13.759-21.744-7.875-4.957,13.757a.7.7,0,0,1-.744.462,51.928,51.928,0,0,0-16.693.766.7.7,0,0,1-.784-.391l-6.2-13.236-20.93,9.847,6.2,13.238a.705.705,0,0,1-.2.851,52.2,52.2,0,0,0-11.257,12.384.708.708,0,0,1-.831.278L392.732,811.9l-7.856,21.8L398.6,838.67a.705.705,0,0,1,.46.744,52.347,52.347,0,0,0,.765,16.737.705.705,0,0,1-.363.769l-13.38,7,9.959,20.22,13.214-6.217a.709.709,0,0,1,.853.2A52.1,52.1,0,0,0,422.461,889.4a.7.7,0,0,1,.277.829Zm33.426-26.871a31.719,31.719,0,1,1,13.421-3.021,31.6,31.6,0,0,1-13.421,3.021m-.039-62.052a30.061,30.061,0,0,0-12.822,2.887,30.371,30.371,0,0,0-14.523,40.308,30.193,30.193,0,0,0,40.2,14.559,30.373,30.373,0,0,0,14.523-40.309,30.292,30.292,0,0,0-27.383-17.445",
    transform: "translate(-260.712 -528.748)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1588",
    "data-name": "Caminho 1588",
    d: "M355.89,581.318c0,7.484-5.645,13.551-12.607,13.551s-12.607-6.067-12.607-13.551,5.645-13.551,12.607-13.551,12.607,6.067,12.607,13.551",
    transform: "translate(-224.936 -386.214)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2218",
    "data-name": "Ret\\xE2ngulo 2218",
    width: 16.876,
    height: 28.542,
    transform: "translate(105.739 193.735)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1589",
    "data-name": "Caminho 1589",
    d: "M380.219,651.315a.7.7,0,0,1-.705-.7V630.39a.705.705,0,1,1,1.41,0v20.22a.7.7,0,0,1-.705.7",
    transform: "translate(-258.158 -428.333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1590",
    "data-name": "Caminho 1590",
    d: "M343.635,576.134c-5.2,5.8-13.224,7.088-17.917,2.88s-4.279-12.321.924-18.119,15.072-4.815,19.764-.607,2.431,10.048-2.771,15.846",
    transform: "translate(-219.343 -378.78)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1591",
    "data-name": "Caminho 1591",
    d: "M110.527,1622.133l-25.512-11.844,17.186-32.06,25.511,11.844Z",
    transform: "translate(-57.83 -1073.565)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1592",
    "data-name": "Caminho 1592",
    d: "M66.25,1700.818H16.333l20.416-36.092,36.818-3.185Z",
    transform: "translate(-11.11 -1130.237)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1593",
    "data-name": "Caminho 1593",
    d: "M64.75,1700.02H14.833a.7.7,0,0,1-.614-1.052l20.416-36.092a.7.7,0,0,1,.553-.356l36.819-3.185a.694.694,0,0,1,.583.229.707.707,0,0,1,.171.6l-7.318,39.278a.706.706,0,0,1-.693.576m-48.708-1.411H64.163l7.041-37.79-35.524,3.074Z",
    transform: "translate(-9.61 -1128.733)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1594",
    "data-name": "Caminho 1594",
    d: "M102.319,1668.631,57.96,1677l8.641-15.461h35.282Z",
    transform: "translate(-39.426 -1130.237)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1595",
    "data-name": "Caminho 1595",
    d: "M58.633,1796.391H49.162l-4.042-4.481-4.055,4.481H22.008l-4.278-4.481-4.438,4.481H0l1.8-14.76H56.829Z",
    transform: "translate(0 -1211.926)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1596",
    "data-name": "Caminho 1596",
    d: "M448.868,1738.87a22.046,22.046,0,0,0,.277-3.476c0-12.968-11.3-23.482-25.232-23.482s-25.232,10.513-25.232,23.482a22.079,22.079,0,0,0,.277,3.476Z",
    transform: "translate(-271.196 -1164.5)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1597",
    "data-name": "Caminho 1597",
    d: "M447.368,1738.075h-49.91a.705.705,0,0,1-.7-.594,22.933,22.933,0,0,1-.286-3.587c0-13.337,11.636-24.186,25.938-24.186s25.937,10.85,25.937,24.186a22.966,22.966,0,0,1-.286,3.587.706.706,0,0,1-.7.594m-49.3-1.41h48.69a21.522,21.522,0,0,0,.182-2.771c0-12.558-11-22.776-24.527-22.776s-24.527,10.218-24.527,22.776a21.409,21.409,0,0,0,.182,2.771",
    transform: "translate(-269.696 -1163.001)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1598",
    "data-name": "Caminho 1598",
    d: "M428.3,1712.612H374.851l6.538-31.487h27.3Z",
    transform: "translate(-254.986 -1143.558)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1599",
    "data-name": "Caminho 1599",
    d: "M421.421,1687.222l-33.431,5.155,2.336-11.252h27.3Z",
    transform: "translate(-263.924 -1143.558)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1600",
    "data-name": "Caminho 1600",
    d: "M505.7,1722.943a.7.7,0,0,1-.6-.333l-5.113-8.209a.7.7,0,1,1,1.2-.745l5.113,8.209a.705.705,0,0,1-.6,1.078",
    transform: "translate(-340.04 -1165.461)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1601",
    "data-name": "Caminho 1601",
    d: "M431.435,1713.656h-.022l-58.084-1.839a.705.705,0,0,1-.669-.848l6.537-31.487a.706.706,0,0,1,.691-.562h27.3a.7.7,0,0,1,.6.333l6.716,10.782c10.563,3.321,17.641,12.5,17.641,22.917a.705.705,0,0,1-.705.705m-57.223-3.222,56.506,1.788c-.324-9.572-7.026-17.921-16.882-20.917a.7.7,0,0,1-.393-.3l-6.649-10.673H380.462Z",
    transform: "translate(-253.486 -1142.058)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1602",
    "data-name": "Caminho 1602",
    d: "M431.39,1711.851h0l-58.041-.034a.706.706,0,0,1-.69-.848l6.538-31.488a.706.706,0,0,1,.691-.562h27.3a.7.7,0,0,1,.6.333l6.853,11a.7.7,0,0,1-1.2.745l-6.646-10.669H380.461l-6.245,30.078,57.175.034a.705.705,0,0,1,0,1.41",
    transform: "translate(-253.485 -1142.057)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1603",
    "data-name": "Caminho 1603",
    d: "M430.106,1795.007h-10.3l-4.4-4.76-4.41,4.76H390.277l-4.653-4.76-4.826,4.76H366.344l1.961-15.413h59.839Z",
    transform: "translate(-249.2 -1210.541)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1604",
    "data-name": "Caminho 1604",
    d: "M202.463,1097.41l-23.919-125.9-46.5,7.651,27,111.047-60.705,91.928,40.964,21.859Z",
    transform: "translate(-66.895 -660.851)",
    fill: "#7d0000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1605",
    "data-name": "Caminho 1605",
    d: "M229.313,1093.738l14.192,83.888-61.744,101.886,14.29,7.625,63.157-106.58Z",
    transform: "translate(-123.64 -743.998)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1606",
    "data-name": "Caminho 1606",
    d: "M382.6,1216.067l-13.074-108.173v-112.6h-60.3L334,1099.97l-5.162,116.1Z",
    transform: "translate(-210.349 -677.032)",
    fill: "#7d0000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1607",
    "data-name": "Caminho 1607",
    d: "M375.8,1215.272H322.042a.7.7,0,0,1-.7-.736l5.157-116-17.884-72.8-9.01-4.921a.705.705,0,0,1,.676-1.238l9.282,5.07a.7.7,0,0,1,.346.451l17.982,73.2a.692.692,0,0,1,.02.2l-5.129,115.361H375l-12.979-107.383a.755.755,0,0,1,0-.085v-112.6a.705.705,0,1,1,1.41,0v112.558L376.5,1214.482a.706.706,0,0,1-.7.79",
    transform: "translate(-203.549 -675.532)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1608",
    "data-name": "Caminho 1608",
    d: "M298.005,1009.553l-88.813,8.3-5.1-20.99h93.917Z",
    transform: "translate(-138.828 -678.101)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1609",
    "data-name": "Caminho 1609",
    d: "M730.678,479.534l6.274.51,1.589-14.5c.234-2.134-.981-3.978-2.714-4.119s-3.327,1.474-3.561,3.608Z",
    transform: "translate(-497.032 -313.874)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1610",
    "data-name": "Caminho 1610",
    d: "M748.512,493.265l6.442.524,1.589-14.5c.234-2.134-.981-3.978-2.714-4.119s-3.327,1.475-3.561,3.609Z",
    transform: "translate(-509.163 -323.224)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1611",
    "data-name": "Caminho 1611",
    d: "M768.17,503.085l5.6.456,1.419-12.945c.209-1.906-.876-3.552-2.424-3.678s-2.971,1.317-3.18,3.223Z",
    transform: "translate(-522.535 -331.213)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1612",
    "data-name": "Caminho 1612",
    d: "M713.08,438.437l5.555,4.295,10.95-27.043a3.859,3.859,0,0,0-1.445-4.786A2.91,2.91,0,0,0,724,412.522Z",
    transform: "translate(-485.061 -279.258)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1613",
    "data-name": "Caminho 1613",
    d: "M675.409,492.846,685.87,484.7l-6.614-23.925c-.415-2.038-2.128-3.165-3.826-2.517a4.326,4.326,0,0,0-2.324,4.863l2.252,11.067Z",
    transform: "translate(-457.807 -311.596)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1614",
    "data-name": "Caminho 1614",
    d: "M666.514,520.456,659.678,542.8l22.046,8.731,6.306-19.775,11.93-20.776L676.754,497.8Z",
    transform: "translate(-448.735 -338.619)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1615",
    "data-name": "Caminho 1615",
    d: "M659.678,602.928l22.046,8.731,3.838-12.113L664.74,586.19Z",
    transform: "translate(-448.735 -398.747)",
    fill: "#020202"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1616",
    "data-name": "Caminho 1616",
    d: "M749.4,478.839a.691.691,0,0,1-.076,0,.705.705,0,0,1-.625-.777l1.4-12.928c.223-2.029-.332-2.592-.9-2.875a.705.705,0,1,1,.625-1.264c1.829.906,1.835,2.884,1.68,4.292l-1.4,12.926a.705.705,0,0,1-.7.63",
    transform: "translate(-509.29 -313.532)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1617",
    "data-name": "Caminho 1617",
    d: "M755.243,491.408a.745.745,0,0,1-.079,0,.705.705,0,0,1-.623-.779l1.428-12.908a3.455,3.455,0,0,0-.678-2.572,2.019,2.019,0,0,0-1.392-.765c-1.346-.126-2.61,1.227-2.8,2.982L750.1,486.4a.705.705,0,0,1-1.4-.154l.991-9.043c.275-2.505,2.193-4.4,4.319-4.234a3.425,3.425,0,0,1,2.365,1.273,4.869,4.869,0,0,1,.993,3.625l-1.428,12.909a.706.706,0,0,1-.7.627",
    transform: "translate(-509.29 -321.726)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1618",
    "data-name": "Caminho 1618",
    d: "M717.654,441.082a.705.705,0,0,1-.655-.966l10.43-26.191a3.146,3.146,0,0,0-1.138-3.911,2.042,2.042,0,0,0-1.677-.171,2.531,2.531,0,0,0-1.467,1.45l-10.917,25.915a.706.706,0,1,1-1.3-.548l10.917-25.914a3.938,3.938,0,0,1,2.313-2.237,3.421,3.421,0,0,1,2.828.279,4.586,4.586,0,0,1,1.747,5.674l-10.425,26.178a.7.7,0,0,1-.655.444",
    transform: "translate(-483.56 -277.754)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1619",
    "data-name": "Caminho 1619",
    d: "M661.444,511.1a.7.7,0,0,1-.673-.917l5.757-18.353-.226-19.07-2.238-11a4.99,4.99,0,0,1,2.764-5.662,3.29,3.29,0,0,1,2.8.18,4.136,4.136,0,0,1,1.969,2.856l4.16,15.04a.705.705,0,0,1-1.36.376l-4.171-15.087a2.779,2.779,0,0,0-1.278-1.948,1.872,1.872,0,0,0-1.617-.1,3.656,3.656,0,0,0-1.885,4.063l2.252,11.066a.707.707,0,0,1,.015.132l.228,19.249a.722.722,0,0,1-.033.22l-5.791,18.46a.705.705,0,0,1-.673.494",
    transform: "translate(-449.457 -310.096)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1620",
    "data-name": "Caminho 1620",
    d: "M696.857,506.976a.705.705,0,0,1-.637-1.006L700.928,496a.705.705,0,0,1,1.276.6l-4.707,9.975a.706.706,0,0,1-.639.4",
    transform: "translate(-473.547 -337.118)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1621",
    "data-name": "Caminho 1621",
    d: "M730.816,539.464a.716.716,0,0,1-.216-.034.706.706,0,0,1-.455-.888l5.124-15.905a.7.7,0,0,1,.06-.135l11.038-19.232a8.249,8.249,0,0,0,1.022-3.185l1.213-11.064a3.009,3.009,0,0,0-.589-2.241,1.727,1.727,0,0,0-1.191-.656c-1.163-.108-2.255,1.069-2.422,2.6l-1.1,10.05a.705.705,0,1,1-1.4-.154l1.1-10.05c.251-2.278,2.015-3.993,3.939-3.848a3.134,3.134,0,0,1,2.164,1.165,4.423,4.423,0,0,1,.9,3.293l-1.213,11.064a9.665,9.665,0,0,1-1.2,3.733l-11,19.167-5.1,15.835a.706.706,0,0,1-.672.489",
    transform: "translate(-496.646 -329.716)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1622",
    "data-name": "Caminho 1622",
    d: "M33.291,513.918l-.388.224a3.1,3.1,0,0,0-1.263,3.534l.394,1.347a2.624,2.624,0,0,0-3.79-1.7,3.366,3.366,0,0,0-1.37,3.833l3.586,12.282a13.534,13.534,0,0,0,2.3,4.538l1.474,1.912-.039.017-1.562-2a13.655,13.655,0,0,1-2.347-4.661l-2.02-7.151a2.533,2.533,0,0,0-3.675-1.768l-.207.12a3.22,3.22,0,0,0-1.312,3.665l2.567,8.821a13.656,13.656,0,0,0,1.882,3.968,12.578,12.578,0,0,1-1.106-1.4L22.4,533.581a2.411,2.411,0,0,0-3.978-.217l-.16.194a3.377,3.377,0,0,0-.147,3.96l5.027,7.282a11.794,11.794,0,0,0,3.507,3.361l13.41,8.233,3.364,14.083,17-5.516.093-16.386a26.493,26.493,0,0,0-1.026-7.468L55.544,527.4a2.894,2.894,0,0,0-3.743-2.164l-.256.1a3.549,3.549,0,0,0-1.878,4.312L53.5,542.964l-1.345-.335a3.568,3.568,0,0,1-1.591-.894l-8.031-10.27a15.849,15.849,0,0,1-2.724-5.41l-2.982-10.442a2.439,2.439,0,0,0-3.538-1.694m-.907,6.305,2.9,9.938a14.036,14.036,0,0,0,.815,2.125,14.092,14.092,0,0,1-.994-2.531Z",
    transform: "translate(-11.934 -349.373)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1623",
    "data-name": "Caminho 1623",
    d: "M94.165,666.984l17-5.516.038-6.73-19.067,5.233Z",
    transform: "translate(-62.677 -445.375)",
    fill: "#020202"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1624",
    "data-name": "Caminho 1624",
    d: "M81.635,543.762a.725.725,0,0,1-.172-.021l-.27-.068a7.134,7.134,0,0,1-3.9-2.594l-7.115-9.1a16.456,16.456,0,0,1-2.847-5.652l-2.983-10.442a2.044,2.044,0,0,0-1.152-1.379,1.519,1.519,0,0,0-1.355.1l-.387.224a2.4,2.4,0,0,0-.94,2.726l3.645,12.485a12.724,12.724,0,0,0,2.18,4.3l4.479,5.733a.705.705,0,1,1-1.112.868l-4.479-5.733a14.14,14.14,0,0,1-2.422-4.774l-3.645-12.485a3.789,3.789,0,0,1,1.588-4.342l.387-.224a2.94,2.94,0,0,1,2.589-.19,3.445,3.445,0,0,1,1.981,2.3l2.983,10.442a15.03,15.03,0,0,0,2.6,5.17l7.115,9.1a5.743,5.743,0,0,0,3.127,2.1l.27.068a.705.705,0,0,1-.171,1.389",
    transform: "translate(-40.136 -348.95)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1625",
    "data-name": "Caminho 1625",
    d: "M54.634,550.865a.7.7,0,0,1-.556-.271l-3.836-4.91a14.138,14.138,0,0,1-2.422-4.773l-3.586-12.283a4.048,4.048,0,0,1,1.695-4.641,3.1,3.1,0,0,1,2.693-.226,3.645,3.645,0,0,1,2.123,2.311.705.705,0,1,1-1.339.443,2.243,2.243,0,0,0-1.285-1.435,1.7,1.7,0,0,0-1.485.128,2.662,2.662,0,0,0-1.047,3.025l3.586,12.283a12.73,12.73,0,0,0,2.18,4.3l3.836,4.911a.705.705,0,0,1-.555,1.139",
    transform: "translate(-29.97 -356.139)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1626",
    "data-name": "Caminho 1626",
    d: "M42.007,596.518l-4.414-15.441-12.821-7.871a12.427,12.427,0,0,1-3.719-3.56l-5.027-7.283a4.066,4.066,0,0,1,.183-4.808l.16-.2a3.167,3.167,0,0,1,2.589-1.2,3.23,3.23,0,0,1,2.518,1.47l4.778,6.8a.705.705,0,0,1-1.154.812l-4.785-6.813a1.842,1.842,0,0,0-1.421-.862,1.755,1.755,0,0,0-1.434.688l-.161.2a2.665,2.665,0,0,0-.112,3.111l5.027,7.282a11.019,11.019,0,0,0,3.3,3.16L38.8,580.163l4.144,14.5,15.273-5.744.09-15.9a25.647,25.647,0,0,0-1-7.268l-3.948-13.709a2.579,2.579,0,0,0-1.273-1.621,1.872,1.872,0,0,0-1.541-.079l-.255.1a2.839,2.839,0,0,0-1.453,3.458l4.935,17.133a.705.705,0,0,1-1.355.39l-4.935-17.133a4.27,4.27,0,0,1,2.305-5.166l.255-.1a3.287,3.287,0,0,1,2.674.133,3.989,3.989,0,0,1,2,2.493l3.948,13.708a27.084,27.084,0,0,1,1.054,7.667l-.1,16.871Z",
    transform: "translate(-10.426 -373.313)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1627",
    "data-name": "Caminho 1627",
    d: "M41.345,568.569a.705.705,0,0,1-.546-.257l-3.435-4.182a14.158,14.158,0,0,1-2.433-4.787l-2.567-8.822A3.9,3.9,0,0,1,34,546.048l.205-.119a3.027,3.027,0,0,1,2.669-.193,3.547,3.547,0,0,1,2.039,2.379l.154.543a.705.705,0,1,1-1.357.384l-.154-.544a2.15,2.15,0,0,0-1.212-1.456,1.6,1.6,0,0,0-1.431.107l-.206.119a2.516,2.516,0,0,0-.989,2.857l2.567,8.821a12.733,12.733,0,0,0,2.18,4.3l3.424,4.169a.705.705,0,0,1-.544,1.153",
    transform: "translate(-21.902 -371.077)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1628",
    "data-name": "Caminho 1628",
    d: "M95.371,672.291l6.863,71.389c1.077,11.2-5.933,21.284-15.656,22.524S68.1,759.371,67.024,748.171l-6.863-71.389Z",
    transform: "translate(-40.924 -457.315)",
    fill: "#fed101"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1629",
    "data-name": "Caminho 1629",
    d: "M633.378,611.469,600.862,599.4,576.779,659.37l28.668,21.364Z",
    transform: "translate(-392.345 -407.73)",
    fill: "#fed101"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1630",
    "data-name": "Caminho 1630",
    d: "M210.471,689.263l-72.9.036c-6.748,0-13.153,3.427-17.511,9.362l-33.4,45.482c-6.311,8.61-5.367,21.482,2.109,28.751s18.65,6.181,24.961-2.429l9.207-12.518-1.741,31.509h96.226V740.225L243.952,760.7a13.4,13.4,0,0,0,9.6,2.817c5.358-.55,9.962-4.626,12.156-10.284l7.993-20.612-50.5-38.931a20.855,20.855,0,0,0-12.728-4.431",
    transform: "translate(-56.104 -468.86)",
    fill: "#fed101"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1631",
    "data-name": "Caminho 1631",
    d: "M94.045,783.9a.705.705,0,0,1-.568-1.122l26.25-35.816a.705.705,0,0,1,1.138.833l-26.25,35.816a.7.7,0,0,1-.57.288",
    transform: "translate(-63.493 -507.913)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1632",
    "data-name": "Caminho 1632",
    d: "M207.609,806.647h-.042a.7.7,0,0,1-.663-.745l2.61-44.465a.705.705,0,1,1,1.408.082l-2.61,44.465a.705.705,0,0,1-.7.664",
    transform: "translate(-140.743 -517.502)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1633",
    "data-name": "Caminho 1633",
    d: "M180.2,832.658l11.2-51.966L189.4,820.14Z",
    transform: "translate(-122.577 -531.054)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1634",
    "data-name": "Caminho 1634",
    d: "M589.474,647.38a.705.705,0,0,1-.657-.962l19.774-50.624a.705.705,0,0,1,1.314.514l-19.774,50.624a.706.706,0,0,1-.657.448",
    transform: "translate(-400.5 -404.974)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1635",
    "data-name": "Caminho 1635",
    d: "M516.149,700.408a14.326,14.326,0,0,1-8.714-3.029l-36.818-28.232a.705.705,0,1,1,.858-1.12l36.818,28.232a12.607,12.607,0,0,0,9.1,2.675c4.983-.512,9.416-4.281,11.57-9.837l31.1-79.982-31.632-12.406a.705.705,0,1,1,.515-1.313l32.286,12.662a.7.7,0,0,1,.4.912l-31.359,80.636c-2.346,6.053-7.228,10.164-12.74,10.73a13.487,13.487,0,0,1-1.384.071",
    transform: "translate(-319.942 -404.976)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1636",
    "data-name": "Caminho 1636",
    d: "M459.538,814.537a.706.706,0,0,1-.428-.145l-20.417-15.655a.705.705,0,0,1,.858-1.12l20.417,15.655a.705.705,0,0,1-.43,1.265",
    transform: "translate(-298.225 -542.468)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1637",
    "data-name": "Caminho 1637",
    d: "M460.016,719.553a.7.7,0,0,1-.428-.145L425.573,693.32a22.8,22.8,0,0,0-13.946-4.863l-31.406.019h0a.705.705,0,0,1,0-1.411l31.407-.019a24.2,24.2,0,0,1,14.8,5.153l34.014,26.088a.705.705,0,0,1-.43,1.265",
    transform: "translate(-258.159 -467.353)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1638",
    "data-name": "Caminho 1638",
    d: "M329.745,629.308A7.742,7.742,0,1,1,321.6,622a7.741,7.741,0,0,1,8.148,7.312",
    transform: "translate(-213.779 -423.095)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1639",
    "data-name": "Caminho 1639",
    d: "M321.936,664.714a7.742,7.742,0,1,1-8.148-7.312,7.741,7.741,0,0,1,8.148,7.312",
    transform: "translate(-208.467 -447.179)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1640",
    "data-name": "Caminho 1640",
    d: "M316.9,702.447a7.742,7.742,0,1,1-8.148-7.312,7.741,7.741,0,0,1,8.148,7.312",
    transform: "translate(-205.038 -472.846)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1641",
    "data-name": "Caminho 1641",
    d: "M1324.7,1476.139l.073,5.495.17,13.1.122,9.152.359,26.9.1,7.394.657,49.849h70.393l-.925-72.584-.243-19.406-.225-17.665Z",
    transform: "translate(-901.103 -1004.12)",
    fill: "#ffbe00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1642",
    "data-name": "Caminho 1642",
    d: "M1014.771,1554.221h76.119l23.805-49.85,15.158-31.741,5.4-11.312.809-1.7-22.12-11.8-40.1-21.39-15.955,33.45-.426.895-34.71,72.773a145.273,145.273,0,0,0-7.99,20.671",
    transform: "translate(-690.282 -970.307)",
    fill: "#ffbe00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1643",
    "data-name": "Caminho 1643",
    d: "M1148.306,1460.778l16.381-34.345,110.5,18.136.472,37.07Z",
    transform: "translate(-781.117 -970.308)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1644",
    "data-name": "Caminho 1644",
    d: "M1545,1592a.706.706,0,0,1-.705-.7L1542.9,1481.65a.706.706,0,0,1,.7-.714.73.73,0,0,1,.714.7l1.393,109.654a.705.705,0,0,1-.7.714Z",
    transform: "translate(-1049.531 -1007.383)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1645",
    "data-name": "Caminho 1645",
    d: "M1298.693,1695.325a.705.705,0,0,1-.705-.7l-.748-56.724-12.439-3.692a.706.706,0,0,1,.4-1.353l12.936,3.84a.706.706,0,0,1,.5.667l.755,57.244a.706.706,0,0,1-.7.714Z",
    transform: "translate(-873.622 -1110.707)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1646",
    "data-name": "Caminho 1646",
    d: "M859.238,1177.738l67.341-73.3,99.822-11.478a111.6,111.6,0,0,1,80.11,21.894l45.547,34.485a25.776,25.776,0,1,1-31.118,41.1l-41.864-31.7,16.749,76.472-155.5-2.889-6.111-61.487-39.676,47.85Z",
    transform: "translate(-584.483 -742.97)",
    fill: "#7d0000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1647",
    "data-name": "Caminho 1647",
    d: "M1460.432,1148.053a.7.7,0,0,1-.425-.143l-47.339-35.842a104.843,104.843,0,0,0-75.579-20.654l-23.729,2.729a.705.705,0,0,1-.161-1.4l23.73-2.729a106.207,106.207,0,0,1,76.591,20.931l47.339,35.842a.705.705,0,0,1-.426,1.267",
    transform: "translate(-892.857 -740.981)",
    fill: "#7d0000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1648",
    "data-name": "Caminho 1648",
    d: "M1338.948,950.121a4.434,4.434,0,0,0,4.539,4.418l3.134-.073a5.27,5.27,0,0,1,3.973,1.661l11.9,12.663,6.268,6.676a1.129,1.129,0,0,1,.085.091l8.154,8.671.365.389,2.428,2.586.736.785.11.11.116.128,2.927-2.744.365-.353,16.412-15.414-.085-.085v-.006l-.061-.061-.049-.049v-.006l-6.937-7.388c-2.087-2.221-.231-6.383-4.941-11.391l-11.343-12.073a17.64,17.64,0,0,0-12.992-5.562l-2.568.018a4.836,4.836,0,0,0-4.449,3.043l.006.036-2.89.024a4.823,4.823,0,0,0-4.643,3.651l-1.734.012a4.824,4.824,0,0,0-4.7,3.9l-.378,1.953v.012a4.76,4.76,0,0,0-.663.152c-.109.036-.213.073-.316.116a4.964,4.964,0,0,0-.675.341,4.793,4.793,0,0,0-.785.615,2.417,2.417,0,0,0-.171.183c-.079.085-.146.17-.219.262-.049.061-.1.134-.146.2a.624.624,0,0,0-.073.1c-.049.085-.1.164-.146.255a.588.588,0,0,0-.079.146.91.91,0,0,0-.073.152.025.025,0,0,0-.012.024c-.043.1-.085.195-.122.3a4.019,4.019,0,0,0-.189.67,4.613,4.613,0,0,0-.085.858",
    transform: "translate(-910.798 -634.723)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1649",
    "data-name": "Caminho 1649",
    d: "M1395.151,952.284a.7.7,0,0,1-.514-.222l-5.814-6.187a12.574,12.574,0,0,0-9.152-3.918l-4.541.034a4.112,4.112,0,0,0-3.962,3.116.706.706,0,1,1-1.369-.341,5.524,5.524,0,0,1,5.32-4.185l4.541-.034a13.888,13.888,0,0,1,10.191,4.363l5.814,6.188a.705.705,0,0,1-.514,1.188",
    transform: "translate(-931.769 -639.791)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1650",
    "data-name": "Caminho 1650",
    d: "M1375.5,965.02a.7.7,0,0,1-.514-.223l-7.647-8.138a10.492,10.492,0,0,0-7.628-3.266l-5.448.041a4.128,4.128,0,0,0-4.01,3.33l-.386,1.981a.705.705,0,0,1-1.384-.27l.386-1.981a5.543,5.543,0,0,1,5.383-4.47l5.448-.041h.089a11.8,11.8,0,0,1,8.578,3.711l7.647,8.138a.705.705,0,0,1-.514,1.188",
    transform: "translate(-917.273 -647.571)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1651",
    "data-name": "Caminho 1651",
    d: "M1417.747,987.436a.7.7,0,0,1-.514-.223l-18.264-19.437a.705.705,0,0,1,1.028-.966l17.781,18.924,18.678-17.55-6.651-7.078a6.975,6.975,0,0,1-1.465-3.886,12.836,12.836,0,0,0-3.473-7.5l-11.344-12.072a17,17,0,0,0-12.348-5.342h-.127l-2.569.02a4.1,4.1,0,0,0-3.8,2.6.705.705,0,1,1-1.311-.519,5.5,5.5,0,0,1,5.1-3.487l2.568-.019a18.5,18.5,0,0,1,13.514,5.786l11.344,12.073a14.235,14.235,0,0,1,3.836,8.232,5.929,5.929,0,0,0,1.1,3.157l7.134,7.592a.7.7,0,0,1-.031,1l-19.706,18.516a.7.7,0,0,1-.483.192",
    transform: "translate(-947.786 -633.225)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1652",
    "data-name": "Caminho 1652",
    d: "M1377.415,1005.745a14.608,14.608,0,0,1-10.653-4.608l-18.174-19.342a4.572,4.572,0,0,0-3.44-1.44l-3.138.073a5.178,5.178,0,0,1-4.044-1.821,5.134,5.134,0,0,1,3.885-8.445l5.684-.043h.089a12,12,0,0,1,8.722,3.773l6.364,6.772a.7.7,0,0,1-1.027.965l-6.364-6.772a10.586,10.586,0,0,0-7.694-3.328h-.078l-5.684.043a3.723,3.723,0,0,0-2.818,6.124,3.7,3.7,0,0,0,2.933,1.32l3.139-.074a5.988,5.988,0,0,1,4.5,1.885l18.173,19.341a13.2,13.2,0,0,0,11.72,4,.705.705,0,0,1,.222,1.393,14.714,14.714,0,0,1-2.316.184",
    transform: "translate(-909.306 -659.909)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1653",
    "data-name": "Caminho 1653",
    d: "M1466.421,1055.491l1.049.9,19.706-18.516-4.4-4.576Z",
    transform: "translate(-997.509 -702.887)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1654",
    "data-name": "Caminho 1654",
    d: "M1474.845,1025.03l-37.635,35.23,78.208,83.549a25.776,25.776,0,0,0,37.635-35.23Z",
    transform: "translate(-977.639 -697.26)",
    fill: "#7d0000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1655",
    "data-name": "Caminho 1655",
    d: "M1505.243,1130.667a.706.706,0,0,1-.515-.223l-68.335-73a.705.705,0,0,1,.033-1l37.635-35.23a.709.709,0,0,1,1,.033l65.791,70.283a.706.706,0,0,1-1.03.964l-65.308-69.769-36.606,34.266,67.854,72.488a.705.705,0,0,1-.515,1.187",
    transform: "translate(-976.954 -694.536)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1656",
    "data-name": "Caminho 1656",
    d: "M1011.992,1018.023l15.414,7.935,8.629,4.442.517-1.01,4.1-7.953,1.619-3.146,1.783-3.457,4.193-8.148,7.953-15.45a5.283,5.283,0,0,1,3.359-2.69l3.043-.8a4.382,4.382,0,0,0,1.935-1.077c.091-.085.17-.17.255-.262a4.416,4.416,0,0,0,.633-4.953,3.757,3.757,0,0,0-.2-.341,2.855,2.855,0,0,0-.219-.317,2.948,2.948,0,0,0-.213-.262,2.829,2.829,0,0,0-.3-.31c-.073-.067-.152-.134-.232-.2-.1-.079-.2-.152-.3-.225s-.207-.134-.316-.195a4.491,4.491,0,0,0-2.44-.56h-.025c-.085.012-.164.019-.249.03v-.006h-.006l-.9-1.771a4.706,4.706,0,0,0-.353-.584,5.153,5.153,0,0,0-.426-.523c-.036-.036-.073-.079-.115-.115s-.079-.085-.122-.122c-.1-.1-.213-.189-.329-.28-.012-.006-.024-.018-.043-.03a3.894,3.894,0,0,0-.334-.231,3.44,3.44,0,0,0-.365-.207,1.749,1.749,0,0,0-.219-.1,2.578,2.578,0,0,0-.3-.128,1.262,1.262,0,0,0-.213-.073,1.045,1.045,0,0,0-.183-.055,3.638,3.638,0,0,0-.444-.1q-.2-.037-.4-.055a3.823,3.823,0,0,0-.456-.024,4.733,4.733,0,0,0-1.29.177l-1.667.462a4.832,4.832,0,0,0-5.471-2.233l-2.787.779v-.036a4.819,4.819,0,0,0-5.111-1.7l-2.477.688a17.662,17.662,0,0,0-10.96,8.927l-7.582,14.732c-3.146,6.11-.219,9.6-1.613,12.3l-4.357,8.452Z",
    transform: "translate(-688.391 -661.142)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1657",
    "data-name": "Caminho 1657",
    d: "M1069.548,989.743a.7.7,0,0,1-.322-.079.705.705,0,0,1-.3-.95l3.886-7.549a13.883,13.883,0,0,1,8.6-7l4.375-1.218a5.528,5.528,0,0,1,6.267,2.559.705.705,0,1,1-1.222.705,4.114,4.114,0,0,0-4.668-1.905l-4.374,1.217a12.47,12.47,0,0,0-7.721,6.287l-3.886,7.549a.7.7,0,0,1-.627.382",
    transform: "translate(-727.064 -661.696)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1658",
    "data-name": "Caminho 1658",
    d: "M1089.324,996.849a.7.7,0,0,1-.322-.079.705.705,0,0,1-.3-.95l5.11-9.928a11.808,11.808,0,0,1,7.311-5.953l5.248-1.461a5.546,5.546,0,0,1,6.407,2.816l.916,1.8a.7.7,0,1,1-1.256.641l-.916-1.8a4.128,4.128,0,0,0-4.771-2.1L1101.5,981.3a10.392,10.392,0,0,0-6.435,5.24l-5.11,9.928a.7.7,0,0,1-.627.382",
    transform: "translate(-740.516 -665.458)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1659",
    "data-name": "Caminho 1659",
    d: "M1034.538,1029.606a.7.7,0,0,1-.322-.079l-24.042-12.376a.705.705,0,0,1-.3-.95l4.768-9.262a5.923,5.923,0,0,0,.19-3.339,14.23,14.23,0,0,1,1.422-8.97l7.582-14.728a18.408,18.408,0,0,1,11.4-9.283l2.475-.689a5.507,5.507,0,0,1,5.859,1.951.705.705,0,1,1-1.117.861,4.094,4.094,0,0,0-4.364-1.452l-2.476.688a16.993,16.993,0,0,0-10.523,8.569l-7.582,14.729a12.841,12.841,0,0,0-1.273,8.169,6.963,6.963,0,0,1-.339,4.139l-4.445,8.635,22.788,11.731,11.885-23.087a.705.705,0,0,1,1.254.646l-12.208,23.714a.7.7,0,0,1-.627.382",
    transform: "translate(-686.895 -659.641)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1660",
    "data-name": "Caminho 1660",
    d: "M1077.257,1036.6a.705.705,0,0,1-.084-1.406,13.206,13.206,0,0,0,10.166-7.069l12.147-23.6a5.993,5.993,0,0,1,3.809-3.051l3.037-.793a3.723,3.723,0,1,0-1.939-7.189l-5.474,1.523a10.588,10.588,0,0,0-6.557,5.339l-4.253,8.262a.705.705,0,0,1-1.254-.646l4.253-8.262a12,12,0,0,1,7.432-6.052l5.475-1.523a5.134,5.134,0,1,1,2.674,9.913l-3.037.793a4.58,4.58,0,0,0-2.912,2.332l-12.147,23.6a14.617,14.617,0,0,1-11.25,7.824.675.675,0,0,1-.085,0",
    transform: "translate(-732.308 -674.757)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1661",
    "data-name": "Caminho 1661",
    d: "M1012,1096.375l24.042,12.376-19.274-21.638Z",
    transform: "translate(-688.395 -739.491)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1662",
    "data-name": "Caminho 1662",
    d: "M927.156,1124.047l-46.029-23.214-47.608,94.4a24.9,24.9,0,0,0,11.018,33.44l1.571.793a24.9,24.9,0,0,0,33.44-11.018Z",
    transform: "translate(-565.17 -748.824)",
    fill: "#7d0000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1663",
    "data-name": "Caminho 1663",
    d: "M993.922,1199.97a.7.7,0,0,1-.317-.076.7.7,0,0,1-.312-.947l38.374-76.091-45.4-22.9a.705.705,0,1,1,.635-1.259l46.029,23.213a.7.7,0,0,1,.312.947l-38.692,76.719a.7.7,0,0,1-.63.388",
    transform: "translate(-670.63 -747.322)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1664",
    "data-name": "Caminho 1664",
    d: "M1218.272,1070.942l45.321-5.21-1.19-22.461-48.07,5.527Z",
    transform: "translate(-826.03 -709.668)",
    fill: "#7d0000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1665",
    "data-name": "Caminho 1665",
    d: "M1214.317,1042.247c.328,2.85,11.321,3.927,24.554,2.406s23.695-5.065,23.367-7.916-11.321-3.927-24.554-2.406-23.695,5.065-23.367,7.916",
    transform: "translate(-826.015 -703.118)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1666",
    "data-name": "Caminho 1666",
    d: "M1276.708,1019.755l-20.925,2.406-1.632-20.25,20.237-2.327Z",
    transform: "translate(-853.117 -679.952)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1667",
    "data-name": "Caminho 1667",
    d: "M1273.839,1007.518l-.912-7.933L1252,1001.991l2.013,17.512a19.812,19.812,0,0,0,9.909-1.722,20.435,20.435,0,0,0,9.915-10.262",
    transform: "translate(-851.655 -679.952)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1668",
    "data-name": "Caminho 1668",
    d: "M1254.465,945.26c1.166,10.137-5.324,19.209-14.5,20.263s-17.551-6.308-18.716-16.445,5.324-19.208,14.5-20.263,17.55,6.308,18.716,16.445",
    transform: "translate(-830.646 -631.743)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1669",
    "data-name": "Caminho 1669",
    d: "M1236.726,979.992c-8.81,0-16.544-7.335-17.675-17.169a20.163,20.163,0,0,1,3.279-13.715.705.705,0,1,1,1.164.8,18.753,18.753,0,0,0-3.042,12.756c1.12,9.734,9.167,16.838,17.935,15.825,5.05-.581,8.075-1.716,11.606-6.6a.705.705,0,0,1,1.144.826c-3.818,5.283-7.235,6.561-12.588,7.177a16.008,16.008,0,0,1-1.822.1",
    transform: "translate(-829.145 -645.407)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1670",
    "data-name": "Caminho 1670",
    d: "M1235.747,922.816c9.737,1.518,15.943,7.536,17.108,17.672a20.511,20.511,0,0,1,.13,2.7l-11.664-6.7-20.2-2.373-.1-.1a7.123,7.123,0,0,1,5.544-12.289c3.595.35,6.869.719,9.182,1.079",
    transform: "translate(-829.036 -626.971)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1671",
    "data-name": "Caminho 1671",
    d: "M1257.33,1009.545a2.678,2.678,0,1,0,2.354-2.966,2.678,2.678,0,0,0-2.354,2.966",
    transform: "translate(-855.267 -684.697)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1672",
    "data-name": "Caminho 1672",
    d: "M1228,1051.231a58.209,58.209,0,0,1-5.93-.276c-5.03-.519-7.685-1.691-7.891-3.484a.705.705,0,0,1,1.4-.161c.068.585,1.541,1.716,6.635,2.242a90.953,90.953,0,0,0,32.739-3.764c4.842-1.668,6.019-3.1,5.952-3.688a.7.7,0,1,1,1.4-.161c.207,1.792-2.113,3.536-6.894,5.183a81.632,81.632,0,0,1-16.5,3.444,96.811,96.811,0,0,1-10.917.666",
    transform: "translate(-825.924 -708.337)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1673",
    "data-name": "Caminho 1673",
    d: "M632.543,1765.747H504.174l13.587-29.168h101.2Z",
    transform: "translate(-342.956 -1181.28)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1674",
    "data-name": "Caminho 1674",
    d: "M631.042,1764.952H502.673a.7.7,0,0,1-.639-1l13.587-29.167a.706.706,0,0,1,.639-.408h101.2a.705.705,0,0,1,.639.408l13.587,29.167a.7.7,0,0,1-.639,1m-127.262-1.411H629.935l-12.93-27.757H516.71Z",
    transform: "translate(-341.456 -1179.78)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1675",
    "data-name": "Caminho 1675",
    d: "M607.331,1410.807l-40.986,118.226h88.463l-40.986-118.226a3.435,3.435,0,0,0-6.492,0",
    transform: "translate(-385.247 -958.108)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1676",
    "data-name": "Caminho 1676",
    d: "M675.094,1410.923l-9.108,26.273h24.739l-9.108-26.273a3.452,3.452,0,0,0-6.523,0",
    transform: "translate(-453.026 -958.179)",
    fill: "#ffbe00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1677",
    "data-name": "Caminho 1677",
    d: "M673.273,1594.532H615.53l8.492-23.974h40.759Z",
    transform: "translate(-418.705 -1068.347)",
    fill: "#ffbe00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1678",
    "data-name": "Caminho 1678",
    d: "M654.235,1738.728H565.073l8.492-21.963h72.179Z",
    transform: "translate(-384.382 -1167.802)",
    fill: "#ffbe00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1679",
    "data-name": "Caminho 1679",
    d: "M653.307,1528.342H564.844a.706.706,0,0,1-.667-.936l40.964-118.161a4.164,4.164,0,0,1,7.87,0l40.964,118.161a.705.705,0,0,1-.667.936m-87.472-1.41h86.481l-40.639-117.225a2.753,2.753,0,0,0-5.2,0Zm39.972-117.456h0Z",
    transform: "translate(-383.746 -956.711)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1680",
    "data-name": "Caminho 1680",
    d: "M870.634,182.781l-31.061,53.874a5.529,5.529,0,0,0,4.79,8.291h62.122a5.529,5.529,0,0,0,4.79-8.291l-31.061-53.874a5.529,5.529,0,0,0-9.581,0",
    transform: "translate(-570.598 -122.451)",
    fill: "#fed101"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1681",
    "data-name": "Caminho 1681",
    d: "M914.039,252.41H857.322a3.413,3.413,0,0,1-2.957-5.118l28.358-49.187a3.412,3.412,0,0,1,5.914,0L917,247.292a3.413,3.413,0,0,1-2.957,5.118m-28.359-54.6a1.984,1.984,0,0,0-1.735,1L855.587,248a2,2,0,0,0,1.735,3h56.717a2,2,0,0,0,1.736-3l-28.359-49.187a1.984,1.984,0,0,0-1.735-1m-2.346.651h0Z",
    transform: "translate(-580.854 -133.595)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2219",
    "data-name": "Ret\\xE2ngulo 2219",
    width: 7.065,
    height: 26.978,
    transform: "translate(301.529 76.753)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2220",
    "data-name": "Ret\\xE2ngulo 2220",
    width: 7.065,
    height: 7.075,
    transform: "translate(301.529 106.65)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1682",
    "data-name": "Caminho 1682",
    d: "M1344.359,573.742l-5.23-11.173-6.947,3.268a26.553,26.553,0,0,0-6.283-5.74l2.608-7.238-11.579-4.193-2.608,7.238a26.458,26.458,0,0,0-8.492.39l-3.26-6.964-11.146,5.244,3.26,6.964a26.567,26.567,0,0,0-5.726,6.3l-7.22-2.615-4.183,11.608,7.22,2.615a26.655,26.655,0,0,0,.389,8.513l-7.021,3.671,5.3,10.77,6.947-3.268a26.551,26.551,0,0,0,6.283,5.74l-2.608,7.238,11.579,4.193,2.608-7.238a26.456,26.456,0,0,0,8.492-.39l3.26,6.964,11.145-5.243-3.26-6.965a26.565,26.565,0,0,0,5.726-6.3l7.22,2.614,4.183-11.608-7.22-2.614a26.661,26.661,0,0,0-.389-8.513Zm-26.476,22.831a15.557,15.557,0,1,1,7.459-20.7,15.508,15.508,0,0,1-7.459,20.7",
    transform: "translate(-869.035 -373.221)",
    fill: "#9f0010"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg404);
export default __webpack_public_path__ + "static/media/404.2fc2a81e3d301e526a985590b0f05985.svg";
export { ForwardRef as ReactComponent };